module.exports = __webpack_public_path__ + "static/type-fixes-over-time-eb1f4b717273690989b5fa1b1fccea84.png";